<template>
<v-container id="grad1" class="fill-height" fluid>
  <v-layout>
    <v-row>
      <v-col md="12" class="text-xs-center">
        <h1>Welcome to SSTS (Sealdah Suburban Tracking System)</h1>
      </v-col>
      <v-col md="12">
        <v-row>
          <v-col md="10">
        <carousel-3d :controls-visible="true" :clickable="false" :autoplay="true" :autoplay-timeout="5000" :display="5" :width="900" :height="500">
          <slide :index="0">
            <figure>
              <img src="../assets/chart.png">
              <figcaption>
                Speed Chart - Instant Speed Chart generation of all trains
              </figcaption>
            </figure>
          </slide>
          <slide :index="1">
            <figure>
              <img src="../assets/map.png">
              <figcaption>
                 Colour coded speed map - View speed data of train on map with colour code.
              </figcaption>
            </figure>
          </slide>
          <slide :index="2">
            <figure>
              <img src="../assets/liveview.png">
              <figcaption>
                Live View - View real time location and movement of all the trains on the map
              </figcaption>
            </figure>
          </slide>
          <slide :index="3">
            <figure>
              <img src="../assets/punctuality.png">
              <figcaption>
                Punctuality Report - Instant generation of Train Report of all trains for punctuality analysis.
              </figcaption>
            </figure>
          </slide>
          <slide :index="4">
            <figure>
              <img src="../assets/ctr.png">
              <figcaption>
                Automatic CTR - Instant generation of Combined Train Report of any train.
              </figcaption>
            </figure>
          </slide>
          <slide :index="5">
            <figure>
              <img src="../assets/livestation.png">
              <figcaption>
                Live Station - View positions of the incoming trains for any roadside station which may be used for anounement.
              </figcaption>
            </figure>
          </slide>
          <slide :index="6">
            <figure>
              <img src="../assets/lateruntrains.png">
              <figcaption>
                Monitor the late running trains to minimize detention.
              </figcaption>
            </figure>
          </slide>
          <slide :index="7">
            <figure>
              <img src="../assets/destarrivals.png">
              <figcaption>
                Destination Arrivals - View the arrivals of train at destination station and assign next train.
              </figcaption>
            </figure>
          </slide>
          <slide :index="8">
            <figure>
              <img src="../assets/dashboard.png">
              <figcaption>
                Dashboard - View Statistical reports on punctuality and crew and rake performance in dashboard.
              </figcaption>
            </figure>
          </slide>
        </carousel-3d>
      </v-col>
      <v-col md="2">
        <span  class="font-weight-bold white--text">Learn more about SSTS on YouTube</span>
        <v-list-item href="https://www.youtube.com/watch?v=F4mPrMmamTI" target="_blank">
          <v-icon left dark>play_circle_filled</v-icon>
          <span  class ="white--text">1. Introduction to SSTS</span>
        </v-list-item>
        <v-list-item href="https://www.youtube.com/watch?v=ZudOS9-dDTo&t=6s" target="_blank">
          <v-icon left dark>play_circle_filled</v-icon>
          <span  class ="white--text">2. SSTS Live View</span>
        </v-list-item>
        <v-list-item href="https://www.youtube.com/watch?v=XV1yVgNYet4" target="_blank">
          <v-icon left dark>play_circle_filled</v-icon>
          <span  class ="white--text">3. Puntuality Speed Chart</span>
        </v-list-item>
        <v-list-item href="https://www.youtube.com/watch?v=3cwMS_kSG2w" target="_blank">
          <v-icon left dark>play_circle_filled</v-icon>
          <span  class ="white--text">4. Puntuality Speed Map</span>
        </v-list-item>
        <v-list-item href="https://www.youtube.com/watch?v=iCk46L9LN0g" target="_blank">
          <v-icon left dark>play_circle_filled</v-icon>
          <span  class ="white--text">5. Trains Runnig Late</span>
        </v-list-item>
      </v-col>
    </v-row>
      </v-col>
      <v-col md="12">
        <v-row>
          <v-col md="6">
        <div class ="white--text">
          Software to track the suburban trains of Sealdah division in real time, in the view of increasing punctuality, safety and monitoring of crew and emu rake performances.
        </div>
      </v-col>
        <v-col md="6">
        <div class ="white--text">
          Salient Features : Colour coded Speed Chart, Live View of train movement, Punctuality Reports, Colour coded Speed line on map, Live Station, Automatic CTR preparation, Statistical reports on crew and rake performance.
        </div>
      </v-col>
      </v-row>
      </v-col>
    </v-row>
  </v-layout>
</v-container>
</template>

<script>
import {
  mapState,
  mapGetter,
  mapActions
} from 'vuex'
import axios from 'axios'

export default {
  name: 'home',

  data() {
    return {
      gradient: 'to top, #039BE5, #B3E5FC',
      colors: [
        'green',
        'secondary',
        'yellow darken-4',
        'red lighten-2',
        'orange darken-1',
      ],
      cycle: false,
      slides: [
        'First',
        'Second',
        'Third',
        'Fourth',
        'Fifth',
      ],
      videoId: null,
      startTime: null,

    }
  },
  created() {
    axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
    axios.get(`${process.env.VUE_APP_API_URL}/timetable/trains_between_stns_with_pf?from_stn=SDAH&to_stn=DDJ`)
      .then(response => {
        console.log(response.data)
      })
      .catch(e => {
        console.log(e)
      })
    // that =this
    // setInterval(() => {
    //   axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
    //   axios.get(`${process.env.VUE_APP_API_URL}/train/trainsforperiod/${this.cur_date}`)
    //   .then(response => {
    //     that.summ = this.getSummary(response.data)
    //   })
    //   .catch(e => {
    //     console.log(e)
    //   })
    // }, 60000);


  },
  computed: {
    ...mapState(['curUser']),
  },
  methods: {
    ...mapActions(['updateCurUser']),
    setVideoId (url) {
      this.videoId = this.$youtube.getIdFromURL(url)
      this.startTime = this.$youtube.getTimeFromURL(url)
    }
  }
}
</script>
<style>
.carousel-3d-container figure {
  margin: 0;
}

.carousel-3d-container figcaption {
  position: absolute;
  background-color: rgba(0, 0.5, 0, 0.5);
  color: yellow;
  bottom: 0;
  padding: 15px;
  font-size: 20px;
  min-width: 100%;
  box-sizing: border-box;
}

.carousel-3d-container figheading {
  position: absolute;
  background-color: rgba(0, 0.5, 0, 0.5);
  color: yellow;
  bottom: 0;
  position: absolute;
  bottom: 0;
  padding: 15px;
  font-size: 20px;
  min-width: 100%;
  box-sizing: border-box;
}

#grad1 {
  background-color: #B3E5FC; /* For browsers that do not support gradients */
  background-image: linear-gradient(to bottom right, #E1F5FE, #01579B); /* Standard syntax (must be last) */
}
</style>
